import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class PackageService {

    static getpackage(item) {

        let api = `${API_BASE_URL}${API_PATHS.getpackage}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.search) params.append("search", item.search);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addpackage(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addpackage}`;
        return axiosInstance
            .post(api, data)
    }
    static editpackage(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editpackage}`;
        return axiosInstance
            .put(api, data)
    }

    static addoptions(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addoptions}`;
        return axiosInstance
            .post(api, data)
    }


    static editoptions(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editoptions}`;
        return axiosInstance
            .put(api, data)
    }

    static getoptions(item) {

        let api = `${API_BASE_URL}${API_PATHS.getoptions}`;

        const params = new URLSearchParams();

        if (item?.packageId) params.append("packageId", item.packageId);
        if (item?.id) params.append("id", item.id);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addDayPlan(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addDayPlan}`;
        return axiosInstance
            .post(api, data)
    }

    static editDayPlan(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editDayPlan}`;
        return axiosInstance
            .put(api, data)
    }


    static getDayPlan(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDayPlan}`;

        const params = new URLSearchParams();

        if (item?.packageId) params.append("packageId", item.packageId);
        if (item?.id) params.append("id", item.id);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }


    static addDayHotel(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addDayHotel}`;
        return axiosInstance
            .post(api, data)
    }

    static editDayHotel(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editDayHotel}`;
        return axiosInstance
            .put(api, data)
    }

    static addDayVehicle(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addDayVehicle}`;
        return axiosInstance
            .post(api, data)
    }


    static editDayVehicle(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editDayVehicle}`;
        return axiosInstance
            .put(api, data)
    }

    static addDayFerry(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addDayFerry}`;
        return axiosInstance
            .post(api, data)
    }

    static editDayFerry(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editDayFerry}`;
        return axiosInstance
            .put(api, data)
    }

    static deleteDayFerry(id) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.deleteDayFerry}?id=${id}`;
        return axiosInstance
            .delete(api)
    }

    static addDayActivity(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addDayActivity}`;
        return axiosInstance
            .post(api, data)
    }

    static editDayActivity(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editDayActivity}`;
        return axiosInstance
            .put(api, data)
    }


    static deleteDayActivity(id) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.deleteDayActivity}?id=${id}`;
        return axiosInstance
            .delete(api)
    }

    static calculatePackageOption(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.calculatePackageOption}`;
        return axiosInstance
            .post(api, data)
    }

    static editpackage(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editpackage}`;
        return axiosInstance
            .put(api, data)

    }

    static deletepackage(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletepackage}?id=${id}`;

        return axiosInstance
            .delete(api)
    }

    static deleteoptions(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteoptions}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default PackageService;
